// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img[data-v-038a424c] {\n  height: auto;\n  max-width: 350px;\n}\n", ""]);
// Exports
module.exports = exports;
